import { Dispatch } from "redux";
import { AxnAdminSecurityRule } from "@idw-types/data/management-console/axnadmin";
import { addSecurityRule } from "@redux/actions/security-rules-actions";
import { createAxnAdminSecurityRuleRequest } from "@requests/management-console/create-axn-admin-security-rule";
import { displaySuccessModal, logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";

export const createSecurityRuleReduxRequest = (dispatch: Dispatch) => async (
    securityRule: AxnAdminSecurityRule
) => {
    const { data, error, body } = await createAxnAdminSecurityRuleRequest(securityRule);
    if (data?.response) {
        dispatch(addSecurityRule(data.response));
        displaySuccessModal(
            dispatch,
            resources.requests.createSecurityRule.success.title,
            resources.requests.createSecurityRule.success.message
        );
        return data.response;
    } else if (error) {
        logAndDisplayErrorModal(
            dispatch,
            error,
            resources.requests.createSecurityRule.error.title,
            resources.requests.createSecurityRule.error.message,
            null,
            null,
            body
        );
    }

    return null;
};